import React from 'react'
import { Helmet } from 'react-helmet'

import Page from '../../containers/DraggerGame/PlayGame'
import Seo from '../../containers/Seo'
import bonnechance from '../../games/bonne-chance.json'

const Game = (props) => {
  return (
    <>
      <Seo.BonneChance />
      <Page data={bonnechance} {...props} />
    </>
  )
}

export default Game
